// Shared project status taxonomy — keep in sync with backend core/constants.py.
export const STATUSES = [
  "awaiting_deposit",
  "pending",
  "ai_magicians",
  "human_review",
  "pending_feedback",
  "applying_feedback",
  "final_review",
  "delivered",
  "rejected",
];

export const STATUS_LABELS = {
  awaiting_deposit: "Awaiting Deposit",
  pending: "Pending",
  ai_magicians: "AI Magicians Working",
  human_review: "Human Review",
  pending_feedback: "Pending Feedback",
  applying_feedback: "Applying Feedback",
  final_review: "Final Review",
  delivered: "Delivered",
  rejected: "Rejected",
};

// Pipeline order (without terminal statuses). Used for "Advance" button + progress bar.
export const STATUS_PIPELINE = [
  "pending",
  "ai_magicians",
  "human_review",
  "pending_feedback",
  "applying_feedback",
  "final_review",
  "delivered",
];

export const STATUS_COLORS = {
  awaiting_deposit: "bg-zinc-100 text-zinc-700 border-zinc-200",
  pending: "bg-blue-50 text-blue-700 border-blue-200",
  ai_magicians: "bg-purple-50 text-purple-700 border-purple-200",
  human_review: "bg-indigo-50 text-indigo-700 border-indigo-200",
  pending_feedback: "bg-amber-50 text-amber-700 border-amber-200",
  applying_feedback: "bg-orange-50 text-orange-700 border-orange-200",
  final_review: "bg-rose-50 text-rose-700 border-rose-200",
  delivered: "bg-emerald-50 text-emerald-700 border-emerald-200",
  rejected: "bg-red-50 text-red-700 border-red-200",
};

export function nextStatus(current) {
  const idx = STATUS_PIPELINE.indexOf(current);
  if (idx === -1 || idx >= STATUS_PIPELINE.length - 1) return null;
  return STATUS_PIPELINE[idx + 1];
}
